import React from "react";

const StageSteps = ({ title, helpSteps }) => {
  return (
    <div className="stage-how-container">
      <div className="stage-how-innercontainer" style={{width:"90%", margin:"auto"}}>
        <p className="stage-how-title">{title}</p>
      </div>
      <div className="stage-how-steps-container">
        {helpSteps.map((step, index) => (
          <div key={index} className="stage-how-step">
            <div className="stage-how-step-inner">
              <div>
                <img src={step.src} className="valley-steps-icon" alt="logo" />
              </div>
              <div className="valley-desktop">
                {step.title.map((line, idx) => (
                  <React.Fragment key={idx}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
              <div className="valley-mobile">
                {step.title.map((line, idx) => (
                  <React.Fragment key={idx}>
                    <span>{line}{" "}</span>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StageSteps;
